// import { getUserInfoByEmployerId } from './employerHelper';
// import { getFullNameByUser } from './textHelper';
// import _isNil from 'lodash/isNil';

export const getConfirmCardPaymentBillingDetails = ({ cardHoldersName = '' } = {}) => {
    return { name: cardHoldersName };
};

export const getConfirmCardSetupBillingDetails = params => {
    return getConfirmCardPaymentBillingDetails(params);
};

export const getFakeStripeInvoiceForDisplay = ({ description, amount, currentPeriodStart = 0, currentPeriodEnd = 0 } = {}) => {
    return {
        newInvoice: {
            subtotal: amount,
            total: amount,
            lines: { data: [{ description, amount: amount }] },
            subscription: {
                current_period_start: currentPeriodStart,
                current_period_end: currentPeriodEnd,
            },
        },
    };
};
